import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import { ListGroup } from "react-bootstrap"
import { Link } from "react-router-dom"
import { Lock } from "react-feather"
import AllTextState from "../../../../assets/shared/state/AllTextState"
import { getData } from "../../../../assets/shared/api/ApiCalls"
import SwitchOrganizationModal from "../../../../assets/js/pages/organization/SwitchOrganizationModal"
import { getUserRole } from "../../../../assets/js/app/state/appSessionStorage"

const SwitchOrganization = (): JSX.Element => {
  const [open, setOpen] = React.useState(false)
  const [organizations, setOrganizations] = React.useState<any>()
  const allowedToGetOrgs = ["claim_manager", "claimant", "org_admin", "rehab_manager"]
  const userRole = getUserRole()
  const checkAllowedUsers = allowedToGetOrgs.includes(userRole)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  React.useEffect(() => {
    if(checkAllowedUsers) getData("rest/get_organizations_by_user", setOrganizations)
  }, [])

  if(!organizations || !checkAllowedUsers) return <></>
  if(organizations && organizations?.length < 2) return <></>
  return (
    <div>
      <ListGroup.Item as="li" bsPrefix=" ">
        <Link to="#" className="dropdown-item" onClick={handleClickOpen}>
          <Lock size={16} className="m-r-10" />
          {AllTextState.switchOrganization}
        </Link>
      </ListGroup.Item>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <SwitchOrganizationModal closeFunc={handleClose} organizations={organizations}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default SwitchOrganization
